module.exports = "/_next/static/images/24b6a1a528b5392d5ae948a9745c7abf-hero-xs.png";